export const HEADER_STYLES = {
  root: "sticky top-0 z-50 w-full bg-white h-header",
  container:
    "flex items-center justify-between px-4 lg:px-8 h-full",
  logoContainer: "flex items-center h-full",
  centerContainer: "flex-1 flex items-center justify-center h-full",
  trailingContainer: "flex items-center h-full gap-4 lg:gap-6",
  navContainer: "flex items-center h-full",
  actionsContainer: "flex items-center space-x-2 h-full",
} as const;

export const LOGO_PATHS = {
  primary: "/images/ticketon-logo.svg",
  secondary: "/images/ticketon-logo-dark.svg",
} as const;

export const LOGO_STYLES = {
  link: "mt-[-2px] inline-block",
} as const;
